// import { loginApi } from '../../service/api'

const state = {
  imgUrl: [],
  listData: [],
  page: 1,
  pageNumber: 1
}

const mutations = {
  getMovie (state, payload) {
    // state.imgUrl = payload.res.data[0].imgUrl
    state.listData = state.listData.concat(payload.res.data)
    console.log('state.listData:', state.listData)
    state.page = payload.res.page
    console.log('state.page:', state.page)
    state.pageNumber = Math.ceil(payload.res.total / payload.res.pageSize)
    // switch (payload.tag) {
    //   case 'hotMovies':
    //     state.imgUrl = payload.res
    //     break
    //   case 'newMovies':
    //     state.newMovies = payload.res
    //     break
    //   case 'topMovies':
    //     state.topMovies = payload.res
    //     break
    //   default:
    //     state.hotMovies = payload.res
    // }
  },
  plusPage (state, payload) {
    state.page += 1
  },
  init (state, payload) {
    state.listData = []
    state.page = 1
    state.pageNumber = 1
  }
}
const getters = {
  imgUrlError: state => {
    if (state.imgUrl) {
      return '/' + state.imgUrl[0]
    }
  }
}
const actions = {
  loadMore ({ commit }, data) {
    const { payload } = data
    return new Promise((resolve, reject) => {
      // loginApi({ ...payload }).then(res => {
      //   // console.log(res)
      //   commit({
      //     type: 'getMovie',
      //     tag: 'hotMovies',
      //     res: res
      //   })
      //   resolve(res)
      // })
    })
  },
  plusPage ({ commit }) {
    commit({
      type: 'plusPage'
    })
  },
  initData ({ commit }) {
    commit({
      type: 'init'
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
